<div class="dialog-container" *ngIf="reportGroupWidth">
  <div class="dialog-grid-container" *ngFor="let conversationResult of conversationResultList"
    [ngStyle]="{'grid-template-columns': 'repeat('+ reportGroupWidth +', 1fr)','grid-auto-rows':'minmax(min-content, max-content)'}">
    <div class="dialog-response-item query" *ngIf="!conversationResult.IsResponse">
      <div class="item-container-alt arrow-left-alt">
        <div style="margin-bottom: 8px;"><p class="small-message-alt">{{conversationResult.ConversationMessage.MessageDateTimeConverted}}</p></div>
        <p class="message-alt">{{conversationResult.ConversationMessage.MessageText}}</p>
      </div>
    </div>
    <div class="dialog-response-item" *ngIf="conversationResult.IsResponse">
        <div class="item-container arrow-left">
          <div style="margin-bottom: 8px;"><p class="small-message">{{conversationResult.ConversationMessage.MessageDateTimeConverted}}</p></div>
          <!-- <p class="message">{{conversationResult.ConversationMessage.MessageText}}</p> -->
          <ng-container *ngIf="conversationResult.SummariseResponse; else fullResponse">
            <app-read-more [text]="conversationResult.ConversationMessage.ResponseText" [maxLength]="500"></app-read-more>
          </ng-container>
          <ng-template #fullResponse>
            <p class="response-message" [innerHTML]="conversationResult.ConversationMessage.ResponseText | safe_html"></p>
          </ng-template>          
          <div *ngIf="conversationResult.EPICGroups.length > 0" class="toggle-container">
            <a class="toggle-box" (click)="conversationResult.ShowEPICGroupsByDefault = !conversationResult.ShowEPICGroupsByDefault" [title]="conversationResult.ShowEPICGroupsByDefault ? 'Hide' : 'Show'">
              <span class="toggle-label">{{conversationResult.ShowEPICGroupsByDefault ? 'Hide' : 'Show'}}</span>
              <a [ngClass]="{'toggle-icon': true, 'up' : conversationResult.ShowEPICGroupsByDefault}"></a>
            </a>
          </div>
        </div>
      </div>
      <div style="grid-column:none;"></div>
        <div [ngClass]="{'dialog-item': true, 'hide': !conversationResult.ShowEPICGroupsByDefault}" *ngFor="let reportGroup of conversationResult.EPICGroups" [ngStyle]="{'grid-column': 'span ' + reportGroup.Width, 'grid-row': 'span ' + reportGroup.Height }">
          <div class="item-container">
            <app-reportgroup [setReportGroup]="reportGroup" [pageContent]="pageContent" [hasGap]="'True'" (getRelatedEpics)="getRelatedEpics(conversationResult, reportGroup)" [dialog]="true"></app-reportgroup>
          </div>
        </div>
  </div>
</div>